import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';

import { IMultiSelectOption, IMultiSelectSettings, IMultiSelectTexts } from 'ngx-bootstrap-multiselect';
import { Origem } from '../../domain';

@Component({
    selector: 'sgt-origem-multiselect',
    templateUrl: './origem-multiselect.component.html',
    styleUrls: ['./origem-multiselect.component.less']
})
export class OrigemMultiselectComponent implements OnInit {
    /** Opções de origens disponíveis para seleção */
    @Input() origensOptions: Origem[] = Origem.getAll();

    /** Origenss selecionadas */
    @Input() origens: number[];
    /** Ao alterar a seleção das origens */
    @Output() origensChange = new EventEmitter<number[]>();

    // Settings
    settings: IMultiSelectSettings;
    @Input() pullRight = false;
    @Input() enableSearch = true;
    @Input() showCheckAll = true;
    @Input() showUncheckAll = true;
    @Input() dynamicTitleMaxItems = 0;
    @Input() fixedTitle = false;
    /** Se deve exibir o multiselect acima */
    @Input() dropup = false;
    /** Se deve desabilitar o multiselect */
    @Input() disabled = false;

    // Texts
    texts: IMultiSelectTexts;
    @Input() checkAll = 'Selecionar Todas';
    @Input() uncheckAll = 'Limpar';
    @Input() defaultTitle = 'Nenhuma Origem';
    @Input() checked = 'Origem'
    @Input() checkedPlural = 'Origens';
    @Input() searchPlaceholder = 'Pesquisar...';
    @Input() allSelected = 'Todoas Selecionadas';
    @Input() searchEmptyResult = 'Nenhuma origem encontrada';
    @Input() searchNoRenderText = 'Digite para pesquisar';

    // Options
    options: IMultiSelectOption[];

    ngOnInit() {
        // Settings
        this.settings = {
            pullRight: this.pullRight,
            enableSearch: this.enableSearch,
            containerClasses: `container-multiselect container-multiselect-origem ${this.dropup ? 'dropup' : 'dropdown'}`,
            showCheckAll: this.showCheckAll,
            showUncheckAll: this.showUncheckAll,
            dynamicTitleMaxItems: this.dynamicTitleMaxItems,
            fixedTitle: this.fixedTitle,
        };
        // Texts
        this.texts = {
            checkAll: this.checkAll,
            uncheckAll: this.uncheckAll,
            defaultTitle: this.defaultTitle,
            checked: this.checked,
            checkedPlural: this.checkedPlural,
            searchPlaceholder: this.searchPlaceholder,
            allSelected: this.allSelected,
            searchEmptyResult: this.searchEmptyResult,
            searchNoRenderText: this.searchNoRenderText
        };

        this.create();
    }

    /** Cria as origens para o multiselect */
    private create() {
        this.options = [];
        const selects: IMultiSelectOption[] = [];

        this.origensOptions?.forEach(origem => {
            selects.push({
                id: origem.id,
                name: origem.nome,
                classes: 'multiselect-item-origem'
            });
        });

        this.options = selects;
    }

    /** Ao alterar a seleção das origens */
    onChange() {
        this.origensChange.emit(this.origens);
    }
}
